import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from './shared.module';
import { MaterialModule } from '@shared/public_api';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  exports: [
    /* angular modules */
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    /* third party modules */
    TranslateModule,
    /* project modules */
    MaterialModule,
    SharedModule,
    NgSelectModule,
  ],
})
export class BaseModule {}
